import { Component, OnInit } from '@angular/core';
import { DesignService } from '../../core/services/design.service';

@Component({
  selector: 'app-child-safety-policy',
  templateUrl: './child-safety-policy.component.html',
  styleUrls: ['./child-safety-policy.component.scss'],
})
export class ChildSafetyPolicyComponent implements OnInit {
  constructor(private designService: DesignService) {
    this.designService.setHeaderStyle('privacyAndPolicy');
  }

  ngOnInit() {}
}
